import { render } from "./p-number.vue?vue&type=template&id=2f2235bf&scoped=true"
import script from "./p-number.vue?vue&type=script&lang=js"
export * from "./p-number.vue?vue&type=script&lang=js"

import "./p-number.vue?vue&type=style&index=0&id=2f2235bf&scoped=true&lang=scss"
import "./p-number.vue?vue&type=style&index=1&id=2f2235bf&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2235bf"]])

export default __exports__